<template>
  <v-col :cols="cols">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          readonly
          outlined
          dense
          v-model="formattedDate"
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
          :append-icon="removeIcon ? '' : 'mdi-calendar'"
          :label="label"
          :rules="rules"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        @input="updateDate"
      ></v-date-picker>
    </v-menu>
  </v-col>
</template>

<script>
export default {
  name: "SigfocoDatePicker",
  props: {
    label: String,
    value: String, // v-model binding
    disabled: {
      type: Boolean,
      default: false,
    },
    removeIcon: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    cols: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      menu: false,
      date: this.value || '', // bind date to the value prop
    };
  },
  watch: {
    value(newVal) {
      this.date = newVal || ''; // update date when value prop changes
    }
  },
  computed: {
    formattedDate() {
      return this.date ? this.formatDateDiaMesAno(this.date) : '';
    },
  },
  methods: {
    updateDate(val) {
      this.date = val;
      this.menu = false; 
      this.$emit('input', this.date); // emit the new date to parent component
    },
    formatDateDiaMesAno(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
